import { Box, Button, Fade, Grid, Stack, Typography, useMediaQuery } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "swiper/css/pagination";
import AnimationController from "../../../components/AnimationController/AnimationController";
import styles from "./index.module.scss";
import keppleFullLogo from "../../../assets/images/public/KeppleLargeLogo.png"
import SparkLogo from "../../../assets/images/LandingPage/Opportunity/SparkLogo.png"
import uniLogo from "../../../assets/images/LandingPage/Opportunity/SchoolLogo.png"
import uniHoverLogo from "../../../assets/images/LandingPage/Opportunity/uniHoverLogo.png"

import { pxToRem } from "../../../helpers/setRem";
import AppStore from "../../../assets/images/LandingPage/Product/appstore.png";
import GooglePlayStore from "../../../assets/images/LandingPage/Product/googleplay.png";




const Opportunity = () => {
    const navigate = useNavigate();
    const isMobile = useMediaQuery('(max-width:780px');
    const isSmallLaptop = useMediaQuery('(max-width:1280px');
    const [activeSlide, setActiveSlide] = useState(0);
    const [isHovered, setIsHovered] = useState(false);

    const ref = useRef<HTMLDivElement>(null);
    const { pathname } = useLocation();

    useEffect(() => {
        const timer = setTimeout(() => {
            ref.current?.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }, 100); // Delay might be adjusted based on your needs

        return () => clearTimeout(timer); // Cleanup the timeout if the component unmounts
    }, [pathname]);

    return (
        <div ref={ref} style={{ backgroundColor: styles.shades0, maxWidth: '1900px', width: '100%', alignSelf: 'center' }}>
            <Stack direction="column" width={'100%'} marginTop={isMobile ? pxToRem(80) : pxToRem(80)}> {/* Adjusted pxToRem to simple string for simplification */}
                <AnimationController
                    render={(loadedAnimation) => (
                        <Fade in={loadedAnimation} timeout={1000}>
                            <Stack className={styles.home_1} direction={'column'}>
                                <Stack className={styles.home_4_Container}>
                                    <Stack className={styles.home_4_textBox} direction={'column'}>
                                        <Typography className={styles.home_4_titleBold}>
                                            Current Opportunities at Kepple
                                        </Typography>
                                        <Typography className={styles.home_4_text}>
                                            If you're looking to build a rewarding career with Kepple, we'd love to chat. See our current  opportunities below.
                                        </Typography>
                                    </Stack>
                                </Stack>
                            </Stack>
                        </Fade>
                    )}
                    customThreshold={0.5}
                    animationCanReplay={false}
                />


                <AnimationController
                    render={(loadedAnimation) => (
                        <Fade in={loadedAnimation} timeout={1000}>
                            <Stack className={styles.home_2}>
                                <Typography className={styles.home_titleBold}>
                                    Job Opportunities
                                </Typography>

                                {/* <Stack className={styles.home_2_boxContainer}>
                                    <Stack className={styles.home_2_cardContainer}>

                                        <Stack className={styles.home_2_about}>
                                            <Box
                                                component={"img"}
                                                className={styles.logo}
                                                alt="Kepple Full Logo"
                                                src={keppleFullLogo}
                                            />
                                            <Stack className={styles.home_2_detail}>
                                                {isMobile ?
                                                    <Stack direction={'row'} alignItems={'center'} gap={pxToRem(12)}><Box
                                                        component={"img"}
                                                        className={styles.smallLogo}
                                                        alt="Kepple Full Logo"
                                                        src={keppleFullLogo}
                                                    /><Typography className={styles.home_2_inbox_subtitle}>
                                                            Junior Marketing Coordinator
                                                        </Typography></Stack> :
                                                    <><Typography className={styles.home_2_inbox_subtitle}>
                                                        Junior Marketing Coordinator
                                                    </Typography></>}

                                                <Typography className={styles.home_2_inbox_text}>
                                                    Kepple
                                                </Typography>

                                                <Typography className={styles.home_2_inbox_text}>
                                                    Melbourne, VIC | On-Site | Casual
                                                </Typography>
                                                <Typography className={styles.home_2_inbox_subtext}>
                                                    We're looking for creative, design-oriented minds to join our in-house marketing team. Grow your skills in SEM, social media content creation, and email marketing in this dynamic role.
                                                </Typography>

                                            </Stack>
                                        </Stack>
                                        <button className={styles.keppleButton} onClick={() => navigate('/apply')}>
                                            <Typography className={styles.keppleButtonText}>
                                                Apply Now
                                            </Typography>
                                        </button>
                                    </Stack>

                                </Stack> */}
                                <Stack className={styles.home_2_boxContainer}>
                                    {/* Junior Operations */}
                                    {/* <Stack className={styles.home_2_cardContainer}>
                                        <Stack className={styles.home_2_about}>
                                            <Box
                                                component={"img"}
                                                className={styles.logo}
                                                alt="Kepple Full Logo"
                                                src={keppleFullLogo}
                                            />
                                            <Stack className={styles.home_2_detail}>
                                                {isMobile ?
                                                    <Stack direction={'row'} alignItems={'center'} gap={pxToRem(12)}><Box
                                                        component={"img"}
                                                        className={styles.smallLogo}
                                                        alt="Kepple Full Logo"
                                                        src={keppleFullLogo}
                                                    /><Typography className={styles.home_2_inbox_subtitle}>
                                                            Junior Operations Coordinator
                                                        </Typography></Stack> :
                                                    <><Typography className={styles.home_2_inbox_subtitle}>
                                                        Junior Operations Coordinator
                                                    </Typography></>}

                                                <Typography className={styles.home_2_inbox_text}>
                                                    Spark Relief Teachers
                                                </Typography>

                                                <Typography className={styles.home_2_inbox_text}>
                                                    Melbourne, VIC | On-Site | Casual
                                                </Typography>
                                                <Typography className={styles.home_2_inbox_subtext}>
                                                    Spark Relief Teachers is constantly seeking enthusiastic and driven individuals to join our product team. This is a great opportunity to gain hands-on experience in a startup environment, help coordinate user experience, and contribute to the growth of our platform.
                                                </Typography>

                                            </Stack>
                                        </Stack>
                                        <button className={styles.keppleButton} onClick={() => navigate('/apply')}>
                                            <Typography className={styles.keppleButtonText}>
                                                Apply Now
                                            </Typography>
                                        </button>
                                    </Stack> */}

                                    {/* Casual Relief Teachers */}
                                    <Stack className={styles.home_2_cardContainer}>
                                        <Stack className={styles.home_2_about}>
                                            <Box
                                                component={"img"}
                                                className={styles.logo}
                                                alt="Spark Logo"
                                                src={SparkLogo}
                                            />
                                            <Stack className={styles.home_2_detail}>
                                                {isMobile ?
                                                    <Stack direction={'row'} alignItems={'center'} gap={pxToRem(12)}><Box
                                                        component={"img"}
                                                        className={styles.smallLogo}
                                                        alt="Spark Logo"
                                                        src={SparkLogo}
                                                    /><Typography className={styles.home_2_inbox_subtitle}>
                                                            Casual Relief Teacher
                                                        </Typography></Stack> :
                                                    <><Typography className={styles.home_2_inbox_subtitle}>
                                                        Casual Relief Teacher
                                                    </Typography></>}
                                                <Typography className={styles.home_2_inbox_text}>
                                                    Spark Relief Teachers
                                                </Typography>

                                                <Typography className={styles.home_2_inbox_text}>
                                                    Melbourne, VIC | On-Site | Casual
                                                </Typography>
                                                <Typography className={styles.home_2_inbox_subtext}>
                                                    Are you a qualified teacher in Australia seeking casual employment opportunities? Join Spark Relief Teachers and enjoy the flexibility of working in schools at times that suit your schedule.
                                                </Typography>
                                            </Stack>
                                        </Stack>
                                        <Stack direction={'row'} gap={pxToRem(24)} zIndex={1000}>
                                            <a href="https://www.apple.com/app-store/" target="_blank" rel="noopener noreferrer">
                                                <Button className={styles.appButton}>
                                                    <img src={AppStore} alt="Download on the App Store" />
                                                </Button>
                                            </a>
                                            <a href="https://play.google.com/store" target="_blank" rel="noopener noreferrer">
                                                <Button className={styles.appButton}>
                                                    <img src={GooglePlayStore} alt="Get it on Google Play" />
                                                </Button>
                                            </a>
                                        </Stack>
                                        <button className={styles.sparkButton} onClick={() => window.open('https://www.sparkreliefteachers.com/register', '_blank', 'noopener,noreferrer')}>
                                            <Typography className={styles.sparkButtonText}>
                                                Register
                                            </Typography>
                                        </button>
                                    </Stack>
                                </Stack>
                            </Stack>
                        </Fade>
                    )}
                    customThreshold={0.1}
                    animationCanReplay={false}
                />

                <AnimationController
                    render={(loadedAnimation) => (
                        <Fade in={loadedAnimation} timeout={1000}>
                            <Stack className={styles.home_2}>
                                <Stack className={styles.home_2_textContainer}>
                                    <Typography className={styles.home_titleBold}>
                                        Internship Opportunities
                                    </Typography>
                                    <Stack className={styles.home_2_textBox}>
                                        <Typography className={styles.home_2_text}>
                                            To find out more about how our internship programs are run, visit our internship page.
                                        </Typography>
                                    </Stack>
                                    <button className={styles.learnMoreButton} onClick={() => navigate('/internship')}>
                                        <Typography className={styles.learnMoreButtonText}>
                                            Learn More
                                        </Typography>
                                    </button>
                                </Stack>

                                {/* UX/UI Design Intern Role */}
                                <Stack className={styles.home_2_longCardContainer}>
                                    <Stack direction={'row'} alignItems={'center'} gap={pxToRem(24)}>
                                        <Box
                                            component={"img"}
                                            className={styles.inlineLogo}
                                            alt="Kepple Full Logo"
                                            src={keppleFullLogo}
                                        />
                                        <Stack className={styles.home_2_detail}>
                                            {isMobile ?
                                                <Stack direction={'row'} alignItems={'center'} gap={pxToRem(12)}><Box
                                                    component={"img"}
                                                    className={styles.smallLogo}
                                                    alt="Kepple Full Logo"
                                                    src={keppleFullLogo}
                                                /><Typography className={styles.home_2_inbox_subtitle}>
                                                        UX/UI Design Intern
                                                    </Typography></Stack> :
                                                <><Typography className={styles.home_2_inbox_subtitle}>
                                                    UX/UI Design Intern
                                                </Typography></>}

                                            <Typography className={styles.home_2_inbox_text}>
                                                On-Site | Nov 2025 - Feb 2026
                                            </Typography>
                                            <Typography className={styles.home_2_inbox_subtext}>
                                                The UX/UI Design internship program is designed to give interns hands-on experience by working on a real project to complete over the summer. You'll work directly with Kepple's design team, right here in our Richmond office. Your contribution will be real and meaningful, leaving you with a tangible outcome to showcase your work.
                                            </Typography>
                                        </Stack>
                                    </Stack>

                                    <button
                                        className={styles.unimelbButton}
                                        onClick={() => navigate('/apply')}
                                    >
                                        <Typography className={styles.unimelbButtonText}>
                                            Apply Now
                                        </Typography>
                                    </button>
                                </Stack>

                                {/* Android Developer Intern Role */}
                                <Stack className={styles.home_2_longCardContainer}>
                                    <Stack direction={'row'} alignItems={'center'} gap={pxToRem(24)}>
                                        <Box
                                            component={"img"}
                                            className={styles.inlineLogo}
                                            alt="Kepple Full Logo"
                                            src={keppleFullLogo}
                                        />
                                        <Stack className={styles.home_2_detail}>
                                            {isMobile ?
                                                <Stack direction={'row'} alignItems={'center'} gap={pxToRem(12)}><Box
                                                    component={"img"}
                                                    className={styles.smallLogo}
                                                    alt="Kepple Full Logo"
                                                    src={keppleFullLogo}
                                                /><Typography className={styles.home_2_inbox_subtitle}>
                                                        Android Developer Intern
                                                    </Typography></Stack> :
                                                <><Typography className={styles.home_2_inbox_subtitle}>
                                                    Android Developer Intern
                                                </Typography></>}
                                            <Typography className={styles.home_2_inbox_text}>
                                                On-Site | Nov 2025 - Feb 2026
                                            </Typography>
                                            <Typography className={styles.home_2_inbox_subtext}>
                                                As a software developer intern, you'll gain hands-on experience working with React Native to build Android apps. This internship program runs over the summer and gives you the opportunity to work directly with Kepple's development team, right here in our Richmond office. Your contribution will be real and meaningful, leaving you with a tangible outcome to showcase your work.
                                            </Typography>
                                        </Stack>
                                    </Stack>

                                    <button
                                        className={styles.unimelbButton}
                                        onClick={() => navigate('/apply')}
                                    >
                                        <Typography className={styles.unimelbButtonText}>
                                            Apply Now
                                        </Typography>
                                    </button>
                                </Stack>

                                {/* iOS Developer Intern Role */}
                                <Stack className={styles.home_2_longCardContainer}>
                                    <Stack direction={'row'} alignItems={'center'} gap={pxToRem(24)}>
                                        <Box
                                            component={"img"}
                                            className={styles.inlineLogo}
                                            alt="Kepple Full Logo"
                                            src={keppleFullLogo}
                                        />
                                        <Stack className={styles.home_2_detail}>
                                            {isMobile ?
                                                <Stack direction={'row'} alignItems={'center'} gap={pxToRem(12)}><Box
                                                    component={"img"}
                                                    className={styles.smallLogo}
                                                    alt="Kepple Full Logo"
                                                    src={keppleFullLogo}
                                                /><Typography className={styles.home_2_inbox_subtitle}>
                                                        iOS Developer Intern
                                                    </Typography></Stack> :
                                                <><Typography className={styles.home_2_inbox_subtitle}>
                                                    iOS Developer Intern
                                                </Typography></>}
                                            <Typography className={styles.home_2_inbox_text}>
                                                On-Site | Nov 2025 - Feb 2026
                                            </Typography>
                                            <Typography className={styles.home_2_inbox_subtext}>
                                                As a software developer intern at Kepple, you'll gain hands-on experience building iOS apps. This internship program runs over the summer and gives you the opportunity to work directly with our development team, right here in our Richmond office. Your contribution will be real and meaningful, leaving you with a tangible outcome to showcase your work.
                                            </Typography>
                                        </Stack>
                                    </Stack>

                                    <button
                                        className={styles.unimelbButton}
                                        onClick={() => navigate('/apply')}
                                    >
                                        <Typography className={styles.unimelbButtonText}>
                                            Apply Now
                                        </Typography>
                                    </button>
                                </Stack>
                            </Stack>

                        </Fade>
                    )}
                    customThreshold={0.5}
                    animationCanReplay={false}
                />

                <AnimationController
                    render={(loadedAnimation) => (
                        <Fade in={loadedAnimation} timeout={1000}>
                            <Stack className={styles.home_3} direction={'column'}>
                                <Stack className={styles.home_3_Container}>
                                    <Typography className={styles.home_3_titleBold}>
                                        Future Opportunities
                                    </Typography>

                                    <Typography className={styles.home_3_text}>
                                        We are an expanding team. If we're not currently advertising a role that matches your skills, we'd still be excited to hear from you.
                                    </Typography>

                                    <button className={styles.contactButton} onClick={() => navigate('/contact')}>
                                        <Typography className={styles.contactButtonText}>
                                            Contact Us
                                        </Typography>
                                    </button>
                                    <Stack className={styles.home_3_textBox} direction={'column'} width={'100%'}>
                                        <Typography className={styles.home_3_subtext}>
                                            Our team is  currently made up of:
                                        </Typography>
                                        {isMobile ?
                                            <Grid container className={styles.home_3_gridBox} justifyContent="space-between">
                                                <Grid item className={styles.home_3_gridColumn} alignItems={'start'}>
                                                    <Stack>
                                                        <Typography className={styles.home_3_gridtext}>
                                                            Digital Coordinators
                                                        </Typography>
                                                        <Typography className={styles.home_3_gridtext}>
                                                            Marketing Coordinators
                                                        </Typography>
                                                        <Typography className={styles.home_3_gridtext}>
                                                            Operations Coordinators
                                                        </Typography>
                                                        <Typography className={styles.home_3_gridtext}>
                                                            Product Coordinators
                                                        </Typography>
                                                        <Typography className={styles.home_3_gridtext}>
                                                            General Manager
                                                        </Typography>
                                                    </Stack>
                                                </Grid>
                                                <Grid item className={styles.home_3_gridColumn} alignItems={'center'}>
                                                    <Stack>

                                                        <Typography className={styles.home_3_gridtext}>
                                                            Software Developers
                                                        </Typography>
                                                        <Typography className={styles.home_3_gridtext}>
                                                            UX/UI Designers
                                                        </Typography>
                                                        <Typography className={styles.home_3_gridtext}>
                                                            Account Manager
                                                        </Typography>
                                                        <Typography className={styles.home_3_gridtext}>
                                                            Bookkeeper
                                                        </Typography>
                                                    </Stack>
                                                </Grid>
                                            </Grid>

                                            :
                                            <Grid container className={styles.home_3_gridBox} justifyContent="space-between">
                                                <Grid item className={styles.home_3_gridColumn} alignItems={'start'}>
                                                    <Stack>
                                                        <Typography className={styles.home_3_gridtext}>
                                                            Digital Coordinators
                                                        </Typography>
                                                        <Typography className={styles.home_3_gridtext}>
                                                            Marketing Coordinators
                                                        </Typography>
                                                        <Typography className={styles.home_3_gridtext}>
                                                            Operations Coordinators
                                                        </Typography>
                                                        <Typography className={styles.home_3_gridtext}>
                                                            Product Coordinators
                                                        </Typography>
                                                    </Stack>
                                                </Grid>
                                                <Grid item className={styles.home_3_gridColumn} alignItems={'center'}>
                                                    <Stack>
                                                        <Typography className={styles.home_3_gridtext}>
                                                            General Manager
                                                        </Typography>
                                                        <Typography className={styles.home_3_gridtext}>
                                                            Software Developers
                                                        </Typography>
                                                        <Typography className={styles.home_3_gridtext}>
                                                            UX/UI Designers
                                                        </Typography>
                                                    </Stack>
                                                </Grid>
                                                <Grid item className={styles.home_3_gridColumn} alignItems={'end'}>
                                                    <Stack>
                                                        <Typography className={styles.home_3_gridtext}>
                                                            Account Manager
                                                        </Typography>
                                                        <Typography className={styles.home_3_gridtext}>
                                                            Bookkeeper
                                                        </Typography>
                                                    </Stack>
                                                </Grid>
                                            </Grid>}
                                    </Stack>
                                </Stack>
                            </Stack>
                        </Fade>
                    )}
                    customThreshold={0.5}
                    animationCanReplay={false}
                />
            </Stack>
        </div>
    );
};

export default Opportunity;
